module.exports = __webpack_public_path__ + "img/txt-2-f@2x.53938ffb.png";